import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';

var JWPlayerComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(JWPlayerComponent, _React$Component);

  var _super = /*#__PURE__*/_createSuper(JWPlayerComponent);

  function JWPlayerComponent(props) {
    _classCallCheck(this, JWPlayerComponent);

    return _super.call(this, props);
  }

  _createClass(JWPlayerComponent, [{
    key: "render",
    value: function render() {
      var _ref = this.props || {},
          element = _ref.element;

      var _ref2 = element || {},
          metadata = _ref2.metadata;

      var _ref3 = metadata || {},
          playerUrl = _ref3["player-url"];

      return /*#__PURE__*/React.createElement("div", {
        className: "jw-player-container"
      }, /*#__PURE__*/React.createElement("iframe", {
        className: "jw-player",
        src: playerUrl,
        allowFullScreen: true,
        frameBorder: "0"
      }));
    }
  }]);

  return JWPlayerComponent;
}(React.Component);

export default JWPlayerComponent;